// extracted by css-extract-rspack-plugin
export default {"wrapper":"ChecksSection-module__wrapper__jba8P","transparentBackground":"ChecksSection-module__transparentBackground__lK5V9","content":"ChecksSection-module__content__vFj9n"};